import { Controller } from "@hotwired/stimulus"

// Auto-submit form controller with debouncing
export default class extends Controller {
  static targets = ["status"]
  static values = {
    delay: { type: Number, default: 500 }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  submit() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.showStatus("Saving...")

    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
      this.showStatus("Saved")

      // Clear status after a moment
      setTimeout(() => {
        this.showStatus("")
      }, 2000)
    }, this.delayValue)
  }

  showStatus(message) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
    }
  }
}
